import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import clsx from 'clsx';

import { openModal } from 'features/utilsSlice';
import useIsLoggedIn from 'hooks/useIsLoggedIn';
import Badge from 'components/Badge';
import CartIcon from 'public/icons/bucket-add.svg';
import styles from 'styles/components/profile/Inventory.module.scss';

const CartButton = () => {
  const cart = useSelector(state => state.cart);
  const dispatch = useDispatch();
  const cartLength = cart.cart_items?.length;
  const isLoggedIn = useIsLoggedIn();

  if (cartLength === 0) return null;

  return (
    <div className={clsx(styles.cartButton, { [styles.notLoggedIn]: !isLoggedIn })}>
      <Badge
        content={cartLength}
        badgeStyles={{ left: '33px', right: 'auto', top: '5px', border: '2px solid white' }}
      />

      <Button
        onClick={() => dispatch(openModal({ name: 'Cart' }))}
        variant="contained"
        color="secondary"
        startIcon={<CartIcon />}
        fullWidth
      >
        View Cart
      </Button>
    </div>
  );
};

export default CartButton;
